import * as React from "react";
// import { pure } from 'recompose';
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { isOpen } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isOpen}>
      <StyledComponent.ModalContainerInsider
        isVisible={isOpen}
        style={{
          overflow: "visible",
          width: "auto",
          backgroundColor: "transparent",
        }}
      >
        <div
          className="modal-segmentation"
          style={{ background: "transparent" }}
        >
          {false && (
            <h2
              className="LogoText"
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: "25px",
                color: "#007ADF",
              }}
            >
              {" "}
              {i18next.t("tunnelwatch")}
            </h2>
          )}

          <div className="sequence-content">
            {false && (
              <p style={{ width: "100%", textAlign: "center" }}>
                {i18next.t("merci d avoir utilise les services de tunnelwatch")}
              </p>
            )}
            {false && (
              <p style={{ width: "100%", textAlign: "center" }}>
                {i18next.t("vous aller etre deconnecte , dans un instant")}
              </p>
            )}
            <div className="loaderDeconnexion">
              <div className="lds-spinner">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        </div>
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onAllReinitialization?: any;
  toggleModal?: any;
  isOpen?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/deconnexion/component.tsx